import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';

//jquery declaration
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'SFICompliance';
  chatLink = environment.chatlink;

  // public openForm(){
  //   $("#myForm").show();
  //   // document.getElementById("myForm").style.display = "block";
  // }


  ngOnInit(): void {
    console.log($(window).width());

    // Mobile Navigation
    if ($(window).width() > 993) {
      //alert("abc");
      $("#client").hide();
    }
    else {
      $("#client").show();
    }
  }
}
